<span class="font-weight-medium" data-e2e="account-name">
  {{ account.name }} -
</span>

<br
  *epcFeatureFlag="
    showAccountIdsInNewLine;
    namespace: accountsNamespace;
    equality: true;
    defaultValue: defaultConfigValues[showAccountIdsInNewLine]
  "
/>
<span class="font-weight-medium" data-e2e="account-id">
  {{ account.externalId }}
</span>
@if (account.domainId) {
<span class="font-weight-medium" data-e2e="account-marketing">
  ({{ account.domainId }})
</span>
}
